export default __webpack_public_path__ + "static/media/dice.bff33c7b.png";